(() => {
  "use strict";

  const YOTPO_APP_KEY = "ZMo7LkExdnYNcDjjdMwMYCdD1tFKyARho5AEezkt";
  // These values identify the original products copied into Final Batch. The
  // fallback score/count was verified from their live Shopify reviews metafields
  // on 2026-10-19; Yotpo refreshes the values from the same original products.
  const SOURCE_PRODUCT_REVIEWS = Object.freeze({
    "delta-9-thc-gummies": {
      productId: "8372327481496",
      score: 4.9,
      count: 237,
    },
    "cbda-gummies": { productId: "8372325843096", score: 4.7, count: 222 },
    "cbd-sleep-gummies": { productId: "8372326826136", score: 4.7, count: 200 },
    "true-sleep-full-spectrum-cbn-cbd-thc-softgels": {
      productId: "8372326367384",
      score: 4.4,
      count: 215,
    },
    "pure-full-spectrum-cbd-softgels": {
      productId: "8372325712024",
      score: 4.8,
      count: 248,
    },
  });
  const RESTRICTED_STATES = new Set(["AL", "CA", "TN"]);
  const ELIGIBLE_STATES = [
    ["AK", "Alaska"],
    ["AZ", "Arizona"],
    ["AR", "Arkansas"],
    ["CO", "Colorado"],
    ["CT", "Connecticut"],
    ["DE", "Delaware"],
    ["DC", "District of Columbia"],
    ["FL", "Florida"],
    ["GA", "Georgia"],
    ["HI", "Hawaii"],
    ["ID", "Idaho"],
    ["IL", "Illinois"],
    ["IN", "Indiana"],
    ["IA", "Iowa"],
    ["KS", "Kansas"],
    ["KY", "Kentucky"],
    ["LA", "Louisiana"],
    ["ME", "Maine"],
    ["MD", "Maryland"],
    ["MA", "Massachusetts"],
    ["MI", "Michigan"],
    ["MN", "Minnesota"],
    ["MS", "Mississippi"],
    ["MO", "Missouri"],
    ["MT", "Montana"],
    ["NE", "Nebraska"],
    ["NV", "Nevada"],
    ["NH", "New Hampshire"],
    ["NJ", "New Jersey"],
    ["NM", "New Mexico"],
    ["NY", "New York"],
    ["NC", "North Carolina"],
    ["ND", "North Dakota"],
    ["OH", "Ohio"],
    ["OK", "Oklahoma"],
    ["OR", "Oregon"],
    ["PA", "Pennsylvania"],
    ["RI", "Rhode Island"],
    ["SC", "South Carolina"],
    ["SD", "South Dakota"],
    ["TX", "Texas"],
    ["UT", "Utah"],
    ["VT", "Vermont"],
    ["VA", "Virginia"],
    ["WA", "Washington"],
    ["WV", "West Virginia"],
    ["WI", "Wisconsin"],
    ["WY", "Wyoming"],
  ];

  // This is intentionally used only when the app proxy is unavailable in Shopify's
  // theme editor or a theme preview. It is never a storefront reservation config.
  const PREVIEW_FALLBACK_CONFIG = {
    products: [
      {
        productId: "gid://shopify/Product/15436995199128",
        variantId: "gid://shopify/ProductVariant/67756268224664",
        price: "39.99",
        display: {
          title: "True Vibe Delta-9 THC Gummies - Cherry Limeade",
          handle: "delta-9-thc-gummies",
          variantTitle: "25 mg CBD + 5 mg THC / 20-count",
          image: {
            url: "https://cdn.shopify.com/s/files/1/0655/6018/2936/files/New-Compliant-True-Vibe-Product-Shot-solo.jpg?v=1773086107",
          },
        },
      },
      {
        productId: "gid://shopify/Product/15436995494040",
        variantId: "gid://shopify/ProductVariant/67756271468696",
        price: "39.99",
        display: {
          title: "Pure Full Spectrum CBDA Rosin Gummies",
          handle: "cbda-gummies",
          variantTitle: "15mg per gummy / 20-count",
          image: {
            url: "https://cdn.shopify.com/s/files/1/0655/6018/2936/files/MONTKUSH-CBDA-Gummy-Product-Shot-15mg-strawberry__14061.1719405500.1280.1280.jpg?v=1751982659",
          },
        },
      },
      {
        productId: "gid://shopify/Product/15436995821720",
        variantId: "gid://shopify/ProductVariant/67756274581656",
        price: "59.99",
        display: {
          title: "True Sleep Full Spectrum CBN + CBD Sleep Gummies",
          handle: "cbd-sleep-gummies",
          variantTitle: "5mg CBN + 25mg CBD + 1mg THC / 30-count",
          image: {
            url: "https://cdn.shopify.com/s/files/1/0655/6018/2936/files/New-Compliant-True-Sleep-Product-Shot-Solo_b96b2275-2371-491e-b918-6f6b6a420f5a.jpg?v=1777580766",
          },
        },
      },
      {
        productId: "gid://shopify/Product/15436996182168",
        variantId: "gid://shopify/ProductVariant/67756277891224",
        price: "59.99",
        display: {
          title: "True Sleep Full Spectrum CBN, CBD & THC Softgels",
          handle: "true-sleep-full-spectrum-cbn-cbd-thc-softgels",
          variantTitle: "5mg CBN + 25mg CBD + 1mg THC / 30-count",
          image: {
            url: "https://cdn.shopify.com/s/files/1/0655/6018/2936/files/167_source_1677698269__22901.1686233637.1280.1280.jpg?v=1772736979",
          },
        },
      },
      {
        productId: "gid://shopify/Product/15436996444312",
        variantId: "gid://shopify/ProductVariant/67756280643736",
        price: "54.99",
        display: {
          title: "Pure Full Spectrum CBD Softgels",
          handle: "pure-full-spectrum-cbd-softgels",
          variantTitle: "25mg CBD + 1mg THC / 30-count",
          image: {
            url: "https://cdn.shopify.com/s/files/1/0655/6018/2936/files/MK25mgCBD_1mgTHC-30-count-SoftgelWeb__88015.1719405505.1280.1280.jpg?v=1736462695",
          },
        },
      },
    ],
    tiers: [
      { minimumQuantity: 5, discountPercent: 30 },
      { minimumQuantity: 10, discountPercent: 35 },
      { minimumQuantity: 25, discountPercent: 40 },
      { minimumQuantity: 50, discountPercent: 45 },
    ],
    maxQuantity: 100,
  };

  const stringValue = (value) =>
    value === undefined || value === null ? "" : String(value);
  const numberValue = (value) => {
    const number = Number(value);
    return Number.isFinite(number) ? number : null;
  };
  const pick = (object, keys) => {
    if (!object || typeof object !== "object") return undefined;
    for (const key of keys) {
      if (
        object[key] !== undefined &&
        object[key] !== null &&
        object[key] !== ""
      )
        return object[key];
    }
    return undefined;
  };

  function toCents(value) {
    if (value === undefined || value === null || value === "") return null;
    if (typeof value === "object") {
      const nested = pick(value, [
        "cents",
        "amount_cents",
        "amountCents",
        "price_cents",
        "priceCents",
        "amount",
        "price",
        "value",
      ]);
      return nested === value ? null : toCents(nested);
    }
    if (typeof value === "number")
      return Number.isInteger(value) ? value : Math.round(value * 100);
    const cleaned = String(value).replace(/[^0-9.-]/g, "");
    if (!cleaned || !Number.isFinite(Number(cleaned))) return null;
    return cleaned.includes(".")
      ? Math.round(Number(cleaned) * 100)
      : Number(cleaned);
  }

  function moneyFrom(object, keys) {
    for (const key of keys) {
      const value = object && object[key];
      const cents = toCents(value);
      if (cents !== null) return cents;
    }
    return null;
  }

  function imageUrl(value) {
    if (typeof value === "string") return value;
    if (value && typeof value === "object")
      return stringValue(pick(value, ["url", "src", "originalSrc"]));
    return "";
  }

  function createElement(tag, options = {}) {
    const element = document.createElement(tag);
    if (options.className) element.className = options.className;
    if (options.text !== undefined) element.textContent = options.text;
    if (options.html !== undefined) element.innerHTML = options.html;
    if (options.attributes) {
      Object.entries(options.attributes).forEach(([name, value]) => {
        if (value !== undefined && value !== null)
          element.setAttribute(name, String(value));
      });
    }
    return element;
  }

  function isShopifyThemePreview() {
    if (
      window.Shopify?.designMode === true ||
      window.Shopify?.designMode === "true"
    )
      return true;
    if (
      String(window.Shopify?.theme?.role || "").toLowerCase() === "unpublished"
    )
      return true;
    return Boolean(
      new URLSearchParams(window.location.search).get("preview_theme_id"),
    );
  }

  function init(root) {
    const dataset = root.dataset;
    const copy = (name, fallback = "") => dataset[`copy${name}`] || fallback;
    const selectors = {
      openContent: root.querySelector("[data-open-content]"),
      closed: root.querySelector("[data-closed-state]"),
      tierTracker: root.querySelector("[data-tier-tracker]"),
      tierStatus: root.querySelector("[data-tier-status]"),
      tierProgress: root.querySelector("[data-tier-progress]"),
      tierProgressBar: root.querySelector("[data-tier-progress-bar]"),
      products: root.querySelector("[data-product-list]"),
      productStatus: root.querySelector("[data-product-status]"),
      layout: root.querySelector(".fbr__layout"),
      mainContent: root.querySelector(".fbr__main-content"),
      formSection: root.querySelector(".fbr__form-section"),
      summary: root.querySelector("[data-summary]"),
      summaryEmpty: root.querySelector("[data-summary-empty]"),
      summaryLines: root.querySelector("[data-summary-lines]"),
      summaryTotal: root.querySelector("[data-summary-total]"),
      summaryTotalValue: root.querySelector("[data-summary-total-value]"),
      summarySezzle: root.querySelector("[data-summary-sezzle]"),
      summarySezzleValue: root.querySelector("[data-summary-sezzle-value]"),
      summaryItemCount: root.querySelector("[data-summary-item-count]"),
      summaryTier: root.querySelector("[data-summary-tier]"),
      summarySavings: root.querySelector("[data-summary-savings]"),
      summaryDeadline: root.querySelector("[data-summary-deadline]"),
      reservedUnits: root.querySelector("[data-reserved-units]"),
      editNotice: root.querySelector("[data-edit-notice]"),
      editNoticeMessage: root.querySelector("[data-edit-notice-message]"),
      cartDock: root.querySelector("[data-cart-dock]"),
      cartDockShipping: root.querySelector("[data-cart-dock-shipping]"),
      cartDockTotal: root.querySelector("[data-cart-dock-total]"),
      cartDockTier: root.querySelector("[data-cart-dock-tier]"),
      cartDockMinimize: root.querySelector("[data-cart-dock-minimize]"),
      cartDockMinimizeLabel: root.querySelector(
        "[data-cart-dock-minimize-label]",
      ),
      cartDockMinimizeIcon: root.querySelector(
        "[data-cart-dock-minimize-icon]",
      ),
      form: root.querySelector("[data-reservation-form]"),
      formError: root.querySelector("[data-form-error]"),
      confirmation: root.querySelector("[data-confirmation]"),
      confirmationHeading: root.querySelector("[data-confirmation-heading]"),
      confirmationMessage: root.querySelector("[data-confirmation-message]"),
      confirmationItems: root.querySelector("[data-confirmation-items]"),
      confirmationItemCount: root.querySelector(
        "[data-confirmation-item-count]",
      ),
      confirmationTier: root.querySelector("[data-confirmation-tier]"),
      confirmationSavings: root.querySelector("[data-confirmation-savings]"),
      confirmationSavingsRow: root.querySelector(
        "[data-confirmation-savings-row]",
      ),
      confirmationTotal: root.querySelector("[data-confirmation-total]"),
      editLink: root.querySelector("[data-edit-link]"),
      submit: root.querySelector("[data-submit-button]"),
      stateSelect: root.querySelector("[data-state-select]"),
      scrollToForm: root.querySelector("[data-scroll-to-form]"),
      acknowledgement: root.querySelector("[data-reservation-acknowledgement]"),
      acknowledgementDialog: root.querySelector(
        "[data-reservation-acknowledgement-dialog]",
      ),
      finalSaleAcknowledgement: root.querySelector(
        "[data-final-sale-acknowledgement]",
      ),
      finalSaleError: root.querySelector("[data-final-sale-error]"),
      countdownCard: root.querySelector("[data-countdown-card]"),
      countdownTitle: root.querySelector("[data-countdown-title]"),
    };

    const state = {
      config: null,
      products: [],
      tiers: [],
      cart: [],
      selections: {},
      deadline: null,
      closed: false,
      countdownTimer: null,
      submissionKey: null,
      editToken: null,
      editVersion: null,
      previewFallback: false,
      prelaunch: dataset.prelaunchEnabled === "true",
      acknowledgementTrigger: null,
      summaryVisible: false,
      cartDockMinimized: false,
    };

    const proxyRoot = (() => {
      const configured = (dataset.proxyRoot || "/apps/final-batch").trim();
      return configured.startsWith("/")
        ? configured.replace(/\/+$/, "")
        : "/apps/final-batch";
    })();
    const proxyUrl = (path) => `${proxyRoot}${path}`;
    const storageKey = dataset.storageKey || "montkush-final-batch-cart-v1";
    const showReservedUnits = dataset.showReservedUnits === "true";
    const summaryMobileQuery = window.matchMedia("(max-width: 899px)");

    function updateStickyHeaderOffset() {
      const header =
        document.querySelector("sticky-header") ||
        document.querySelector(".header-wrapper") ||
        document.querySelector("#shopify-section-header") ||
        document.querySelector("body > header");
      const headerHeight = header
        ? Math.ceil(header.getBoundingClientRect().height)
        : 0;
      root.style.setProperty(
        "--fbr-sticky-top",
        `${Math.max(24, headerHeight + 16)}px`,
      );
    }

    function arrangeSummaryForViewport() {
      const { layout, mainContent, formSection, summary } = selectors;
      if (!layout || !mainContent || !formSection || !summary) return;
      if (summaryMobileQuery.matches) {
        if (summary.parentElement !== mainContent)
          mainContent.insertBefore(summary, formSection);
      } else if (summary.parentElement !== layout) {
        layout.append(summary);
      }
    }

    function updateCartDockMinimizedState() {
      if (!selectors.cartDock || !selectors.cartDockMinimize) return;
      const minimized = state.cartDockMinimized;
      const label = minimized
        ? "Show quick batch review"
        : "Minimize quick batch review";
      selectors.cartDock.classList.toggle("is-minimized", minimized);
      selectors.cartDockMinimize.setAttribute(
        "aria-expanded",
        String(!minimized),
      );
      selectors.cartDockMinimize.setAttribute("aria-label", label);
      if (selectors.cartDockMinimizeLabel)
        selectors.cartDockMinimizeLabel.textContent = label;
      if (selectors.cartDockMinimizeIcon)
        selectors.cartDockMinimizeIcon.textContent = minimized ? "+" : "−";
    }

    function toggleCartDockMinimizedState() {
      state.cartDockMinimized = !state.cartDockMinimized;
      updateCartDockMinimizedState();
    }

    function updateCartDockVisibility(hasItems = state.cart.length > 0) {
      if (!selectors.cartDock) return;
      if (!hasItems) state.cartDockMinimized = false;
      updateCartDockMinimizedState();
      selectors.cartDock.hidden = !hasItems || state.summaryVisible;
    }

    function initialiseCartDockObserver() {
      if (
        !selectors.summary ||
        !selectors.cartDock ||
        !("IntersectionObserver" in window)
      )
        return;
      const observer = new IntersectionObserver(
        ([entry]) => {
          state.summaryVisible = Boolean(entry?.isIntersecting);
          updateCartDockVisibility();
        },
        { threshold: 0.01 },
      );
      observer.observe(selectors.summary);
    }

    function initialiseHeroFallback() {
      const selectedMedia = root.querySelector("[data-hero-selected-media]");
      const selectedImage = selectedMedia?.querySelector("img");
      const fallback = root.querySelector("[data-hero-fallback-media]");
      if (!selectedMedia || !selectedImage || !fallback) return;
      selectedImage.addEventListener(
        "error",
        () => {
          selectedMedia.hidden = true;
          fallback.hidden = false;
        },
        { once: true },
      );
    }

    function formatMoney(cents) {
      if (cents === null || cents === undefined || !Number.isFinite(cents))
        return "—";
      try {
        return new Intl.NumberFormat(dataset.locale || "en-US", {
          style: "currency",
          currency: dataset.currency || "USD",
        }).format(cents / 100);
      } catch (error) {
        return `$${(cents / 100).toFixed(2)}`;
      }
    }

    function formatDeadline(value) {
      if (!value) return "";
      const date = new Date(value);
      if (Number.isNaN(date.getTime())) return value || "";
      try {
        return new Intl.DateTimeFormat("en-US", {
          month: "long",
          day: "numeric",
          year: "numeric",
          hour: "numeric",
          minute: "2-digit",
          hour12: true,
          timeZone: "America/New_York",
          timeZoneName: "short",
        })
          .format(date)
          .replace(" at ", " • ");
      } catch (error) {
        return date.toUTCString();
      }
    }

    function setProductStatus(message) {
      if (selectors.productStatus)
        selectors.productStatus.textContent = message || "";
    }

    function showFormError(message) {
      if (!selectors.formError) return;
      selectors.formError.textContent = message;
      selectors.formError.hidden = !message;
    }

    function clearFormError() {
      showFormError("");
    }

    function normalizeProducts(rawProducts) {
      const list = Array.isArray(rawProducts)
        ? rawProducts
        : Object.values(rawProducts || {});
      return list.map((product, productIndex) => {
        const display =
          product.display && typeof product.display === "object"
            ? product.display
            : {};
        const key = stringValue(
          pick(product, ["id", "product_id", "productId", "handle", "slug"]) ||
            display.handle ||
            `product-${productIndex + 1}`,
        );
        const rawVariants =
          Array.isArray(product.variants) && product.variants.length
            ? product.variants
            : product.variant
              ? [product.variant]
              : [product];
        const variants = rawVariants.map((variant, variantIndex) => {
          const variantKey = stringValue(
            pick(variant, ["id", "variant_id", "variantId", "sku"]) ||
              pick(product, ["variant_id", "variantId", "id", "handle"]) ||
              `${key}-${variantIndex + 1}`,
          );
          return {
            key: variantKey,
            id:
              pick(variant, ["id", "variant_id", "variantId", "sku"]) ||
              pick(product, ["variant_id", "variantId", "id"]),
            title: stringValue(
              pick(variant, ["title", "name", "option_title", "optionTitle"]) ||
                display.variantTitle ||
                "",
            ),
            available:
              pick(variant, ["available", "is_available", "isAvailable"]) !==
              false,
            image:
              imageUrl(
                pick(variant, [
                  "image_url",
                  "imageUrl",
                  "image",
                  "featured_image",
                  "featuredImage",
                ]),
              ) || imageUrl(variant.display?.image),
            raw: variant,
          };
        });
        const handle = stringValue(
          pick(product, ["handle", "slug"]) || display.handle,
        );
        return {
          key,
          id: pick(product, ["id", "product_id", "productId"]),
          handle,
          title: stringValue(
            pick(product, ["title", "name"]) ||
              display.title ||
              `Product ${productIndex + 1}`,
          ),
          description: stringValue(
            pick(product, ["short_description", "shortDescription"]) ||
              display.variantTitle ||
              "",
          ),
          image:
            imageUrl(
              pick(product, [
                "image_url",
                "imageUrl",
                "image",
                "featured_image",
                "featuredImage",
              ]),
            ) || imageUrl(display.image),
          review: SOURCE_PRODUCT_REVIEWS[handle]
            ? { ...SOURCE_PRODUCT_REVIEWS[handle] }
            : null,
          raw: product,
          variants,
        };
      });
    }

    function tierThreshold(raw) {
      const threshold = numberValue(
        pick(raw, [
          "minimum_quantity",
          "minimumQuantity",
          "min_quantity",
          "minQuantity",
          "minimum_items",
          "minimumItems",
          "threshold",
          "quantity",
          "items",
        ]),
      );
      return threshold === null ? 0 : Math.max(0, Math.floor(threshold));
    }

    function normalizeTiers(rawTiers) {
      const list = Array.isArray(rawTiers)
        ? rawTiers
        : Object.values(rawTiers || {});
      return list
        .map((tier, index) => {
          const threshold = tierThreshold(tier);
          const discount = Math.round((discountFraction(tier) || 0) * 100);
          return {
            raw: tier,
            id: stringValue(
              pick(tier, ["id", "key", "slug", "name"]) ||
                `tier-${threshold || index + 1}`,
            ),
            label: stringValue(
              pick(tier, ["label", "title", "name"]) ||
                `${threshold}+ items · ${discount}% off`,
            ),
            detail: stringValue(
              pick(tier, [
                "description",
                "detail",
                "discount_label",
                "discountLabel",
              ]) || `${threshold} items unlock ${discount}% off`,
            ),
            threshold,
            index,
          };
        })
        .sort((a, b) => a.threshold - b.threshold || a.index - b.index)
        .slice(0, 4);
    }

    function getProduct(productKey) {
      return state.products.find((product) => product.key === productKey);
    }

    function getVariant(productKey, variantKey) {
      const product = getProduct(productKey);
      if (!product) return null;
      const variant = product.variants.find(
        (candidate) => candidate.key === variantKey,
      );
      return variant ? { product, variant } : null;
    }

    function selectionFor(product) {
      const selectedKey = state.selections[product.key];
      const selected = product.variants.find(
        (variant) => variant.key === selectedKey && variant.available,
      );
      const fallback =
        product.variants.find((variant) => variant.available) ||
        product.variants[0];
      if (fallback) state.selections[product.key] = (selected || fallback).key;
      return selected || fallback;
    }

    function itemCount() {
      return state.cart.reduce((total, item) => total + item.quantity, 0);
    }

    function productQuantity(productKey) {
      return state.cart.reduce(
        (total, item) =>
          item.productKey === productKey ? total + item.quantity : total,
        0,
      );
    }

    function activeTier() {
      const quantity = itemCount();
      return state.tiers.reduce(
        (current, tier) => (quantity >= tier.threshold ? tier : current),
        null,
      );
    }

    function nextTier() {
      const quantity = itemCount();
      return state.tiers.find((tier) => tier.threshold > quantity) || null;
    }

    function discountFraction(rawTier) {
      const raw = pick(rawTier, [
        "discount_percent",
        "discountPercent",
        "discount_percentage",
        "discountPercentage",
        "discount",
        "percent_off",
        "percentOff",
      ]);
      const amount = numberValue(raw);
      if (amount === null) return null;
      return Math.max(0, Math.min(1, amount > 1 ? amount / 100 : amount));
    }

    function mappedTierPrice(mapping, product, variant, tier) {
      if (!mapping) return null;
      if (Array.isArray(mapping)) {
        const match = mapping.find((entry) => {
          const target = stringValue(
            pick(entry, [
              "variant_id",
              "variantId",
              "product_id",
              "productId",
              "handle",
              "id",
            ]),
          );
          return (
            target &&
            [
              stringValue(variant.id),
              variant.key,
              stringValue(product.id),
              product.key,
              stringValue(product.handle),
            ].includes(target)
          );
        });
        return match
          ? moneyFrom(match, [
              "price_cents",
              "priceCents",
              "discounted_price_cents",
              "discountedPriceCents",
              "price",
              "amount",
            ])
          : null;
      }
      if (typeof mapping === "object") {
        for (const candidate of [
          stringValue(variant.id),
          variant.key,
          stringValue(product.id),
          product.key,
          stringValue(product.handle),
        ]) {
          if (candidate && mapping[candidate] !== undefined)
            return toCents(mapping[candidate]);
        }
      }
      return null;
    }

    function basePrice(product, variant) {
      return (
        moneyFrom(variant.raw, [
          "price_cents",
          "priceCents",
          "base_price_cents",
          "basePriceCents",
          "price",
          "amount",
        ]) ??
        moneyFrom(product.raw, [
          "price_cents",
          "priceCents",
          "base_price_cents",
          "basePriceCents",
          "price",
          "amount",
        ])
      );
    }

    function priceFor(product, variant, tier) {
      if (!tier) return basePrice(product, variant);
      const tierId = tier.id;
      const productTierPrices = pick(product.raw, [
        "tier_prices",
        "tierPrices",
        "prices_by_tier",
        "pricesByTier",
      ]);
      const variantTierPrices = pick(variant.raw, [
        "tier_prices",
        "tierPrices",
        "prices_by_tier",
        "pricesByTier",
      ]);
      const tierPriceSources = [
        variantTierPrices && variantTierPrices[tierId],
        productTierPrices && productTierPrices[tierId],
        mappedTierPrice(
          pick(tier.raw, [
            "variant_prices",
            "variantPrices",
            "product_prices",
            "productPrices",
            "prices",
          ]),
          product,
          variant,
          tier,
        ),
        moneyFrom(tier.raw, [
          "price_cents",
          "priceCents",
          "discounted_price_cents",
          "discountedPriceCents",
        ]),
      ];
      for (const source of tierPriceSources) {
        const cents = toCents(source);
        if (cents !== null) return cents;
      }
      const base = basePrice(product, variant);
      const discount = discountFraction(tier.raw);
      return base !== null && discount !== null
        ? Math.round(base * (1 - discount))
        : base;
    }

    function cartTotal() {
      const tier = activeTier();
      let total = 0;
      for (const item of state.cart) {
        const found = getVariant(item.productKey, item.variantKey);
        if (!found) continue;
        const price = priceFor(found.product, found.variant, tier);
        if (price === null) return null;
        total += price * item.quantity;
      }
      return total;
    }

    function cartListPriceTotal() {
      let total = 0;
      for (const item of state.cart) {
        const found = getVariant(item.productKey, item.variantKey);
        if (!found) continue;
        const price = basePrice(found.product, found.variant);
        if (price === null) return null;
        total += price * item.quantity;
      }
      return total;
    }

    function persistCart() {
      try {
        window.localStorage.setItem(storageKey, JSON.stringify(state.cart));
      } catch (error) {
        // Cart persistence is optional; reservation data is never stored here.
      }
    }

    function restoreCart() {
      try {
        const saved = JSON.parse(window.localStorage.getItem(storageKey));
        if (!Array.isArray(saved)) return;
        state.cart = saved
          .map((item) => ({
            productKey: stringValue(item.productKey),
            variantKey: stringValue(item.variantKey),
            quantity: Math.max(1, Math.floor(numberValue(item.quantity) || 1)),
          }))
          .filter((item) => getVariant(item.productKey, item.variantKey));
      } catch (error) {
        state.cart = [];
      }
    }

    function renderTiers() {
      if (!selectors.tierTracker) return;
      selectors.tierTracker.replaceChildren();
      const current = activeTier();
      const quantity = itemCount();
      const topTier = state.tiers[state.tiers.length - 1];
      const topThreshold = topTier?.threshold || 50;
      const progressQuantity = Math.min(quantity, topThreshold);
      const progress = Math.round((progressQuantity / topThreshold) * 100);
      if (selectors.tierProgress) {
        selectors.tierProgress.setAttribute(
          "aria-valuemax",
          String(topThreshold),
        );
        selectors.tierProgress.setAttribute(
          "aria-valuenow",
          String(progressQuantity),
        );
        selectors.tierProgress.setAttribute(
          "aria-valuetext",
          `${quantity} item${quantity === 1 ? "" : "s"} in your batch`,
        );
      }
      if (selectors.tierProgressBar)
        selectors.tierProgressBar.style.width = `${progress}%`;
      const fragment = document.createDocumentFragment();
      state.tiers.forEach((tier) => {
        const active = current && tier.id === current.id;
        const reached = quantity >= tier.threshold;
        const discount = Math.round((discountFraction(tier.raw) || 0) * 100);
        const tierElement = createElement("li", {
          className: `fbr__tier${active ? " fbr__tier--active" : ""}${reached ? " fbr__tier--reached" : " fbr__tier--locked"}`,
          attributes: active ? { "aria-current": "step" } : {},
        });
        tierElement.append(
          createElement("span", {
            className: "fbr__tier-threshold",
            text: `${tier.threshold}+ items`,
          }),
        );
        tierElement.append(
          createElement("strong", {
            className: "fbr__tier-discount",
            text: `Save ${discount}%`,
          }),
        );
        tierElement.append(
          createElement("span", {
            className: "fbr__tier-detail",
            text: reached
              ? "Unlocked"
              : `${Math.max(0, tier.threshold - quantity)} more to unlock`,
          }),
        );
        if (tier.threshold === 25)
          tierElement.append(
            createElement("span", {
              className: "fbr__tier-longevity",
              text: "≈ two years at one a month.",
            }),
          );
        if (reached)
          tierElement.append(
            createElement("span", {
              className: "fbr__tier-check",
              text: "✓",
              attributes: {
                "aria-label": `${tier.threshold} jar tier unlocked`,
              },
            }),
          );
        fragment.append(tierElement);
      });
      selectors.tierTracker.append(fragment);
      if (!selectors.tierStatus) return;
      const next = nextTier();
      if (current) {
        const currentDiscount = Math.round(
          (discountFraction(current.raw) || 0) * 100,
        );
        const nextDiscount = Math.round(
          (discountFraction(next?.raw) || 0) * 100,
        );
        const message = next
          ? `You’re saving ${currentDiscount}% on ${quantity} items. Add ${next.threshold - quantity} more to unlock ${nextDiscount}% off.`
          : `Top discount unlocked: ${currentDiscount}% off on ${quantity} items.`;
        selectors.tierStatus.textContent = message;
      } else if (next) {
        const nextDiscount = Math.round(
          (discountFraction(next.raw) || 0) * 100,
        );
        selectors.tierStatus.textContent = `Add ${next.threshold - quantity} more items to unlock ${nextDiscount}% off.`;
      } else {
        selectors.tierStatus.textContent = "";
      }
    }

    function productImage(product, variant) {
      const image = variant?.image || product.image;
      if (image) {
        return createElement("img", {
          className: "fbr__product-image",
          attributes: {
            src: image,
            alt: variant?.title
              ? `${product.title} — ${variant.title}`
              : product.title,
            loading: "lazy",
            width: "240",
            height: "240",
          },
        });
      }
      return createElement("div", {
        className: "fbr__product-image fbr__product-image--placeholder",
        text: product.title,
      });
    }

    function productRating(product) {
      const review = product.review;
      if (
        !review ||
        !Number.isFinite(review.score) ||
        !Number.isFinite(review.count) ||
        !product.handle
      )
        return null;
      const rating = createElement("a", {
        className: "fbr__rating",
        attributes: {
          href: `/products/${encodeURIComponent(product.handle)}#yotpo-reviews`,
          "data-fbr-yotpo-rating": "",
          "data-yotpo-product-id": review.productId,
          "aria-busy": "true",
          "aria-label": `${review.score.toFixed(1)} out of 5 stars from ${review.count} verified reviews of this formula`,
        },
      });
      const stars = createElement("span", {
        className: "fbr__rating-stars",
        attributes: { "aria-hidden": "true" },
      });
      stars.append(
        createElement("span", {
          className: "fbr__rating-stars-base",
          text: "★★★★★",
        }),
      );
      const fill = createElement("span", {
        className: "fbr__rating-stars-fill",
        text: "★★★★★",
      });
      fill.style.setProperty(
        "--fbr-rating-percent",
        `${Math.min(100, Math.max(0, (review.score / 5) * 100))}%`,
      );
      stars.append(fill);
      rating.append(
        stars,
        createElement("span", {
          className: "fbr__rating-text",
          text: `${review.score.toFixed(1)} · ${review.count} verified reviews`,
        }),
      );
      return rating;
    }

    async function loadProductRating(rating) {
      if (rating.dataset.fbrRatingLoaded === "true") return;
      rating.dataset.fbrRatingLoaded = "true";
      const productId = rating.dataset.yotpoProductId;
      if (!productId) return;
      try {
        const response = await fetch(
          `https://api-cdn.yotpo.com/products/${YOTPO_APP_KEY}/${encodeURIComponent(productId)}/bottomline`,
          { headers: { accept: "application/json" } },
        );
        if (!response.ok) throw new Error("Yotpo rating request failed");
        const bottomline = (await response.json())?.response?.bottomline;
        const score = Number(bottomline?.average_score || 0);
        const count = Number(bottomline?.total_reviews || 0);
        if (!score || !count)
          throw new Error("Yotpo rating response was empty");
        rating
          .querySelector(".fbr__rating-stars-fill")
          ?.style.setProperty(
            "--fbr-rating-percent",
            `${Math.min(100, Math.max(0, (score / 5) * 100))}%`,
          );
        const text = `${score.toFixed(1)} · ${count} verified reviews`;
        const textNode = rating.querySelector(".fbr__rating-text");
        if (textNode) textNode.textContent = text;
        rating.setAttribute(
          "aria-label",
          `${score.toFixed(1)} out of 5 stars from ${count} verified reviews of this formula`,
        );
      } catch (error) {
        // Keep the verified Shopify metafield fallback visible if Yotpo is unavailable.
      } finally {
        rating.setAttribute("aria-busy", "false");
      }
    }

    function initialiseProductRatings() {
      const ratings = [...root.querySelectorAll("[data-fbr-yotpo-rating]")];
      if (!("IntersectionObserver" in window)) {
        ratings.forEach(loadProductRating);
        return;
      }
      const observer = new IntersectionObserver(
        (entries, activeObserver) =>
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              loadProductRating(entry.target);
              activeObserver.unobserve(entry.target);
            }
          }),
        { rootMargin: "200px 0px" },
      );
      ratings.forEach((rating) => observer.observe(rating));
    }

    function summaryThumbnail(product, variant) {
      const image = variant?.image || product.image;
      if (image) {
        return createElement("img", {
          className: "fbr__summary-thumbnail",
          attributes: {
            src: image,
            alt: "",
            loading: "lazy",
            width: "64",
            height: "64",
          },
        });
      }
      return createElement("div", {
        className: "fbr__summary-thumbnail fbr__summary-thumbnail--placeholder",
        attributes: { "aria-hidden": "true" },
      });
    }

    function updateCartCounts(totalItems) {
      root
        .querySelectorAll("[data-cart-count], [data-summary-count]")
        .forEach((element) => {
          element.textContent = String(totalItems);
        });
    }

    function updateSummaryItemCount(totalItems) {
      if (!selectors.summaryItemCount && selectors.summary) {
        const itemCountLabel = createElement("p", {
          className: "fbr__summary-item-count",
          attributes: { "data-summary-item-count": "", "aria-live": "polite" },
        });
        if (selectors.summaryTotal?.parentNode)
          selectors.summaryTotal.parentNode.insertBefore(
            itemCountLabel,
            selectors.summaryTotal,
          );
        else selectors.summary.append(itemCountLabel);
        selectors.summaryItemCount = itemCountLabel;
      }
      if (!selectors.summaryItemCount) return;
      selectors.summaryItemCount.textContent = `${totalItems} item${totalItems === 1 ? "" : "s"} in your batch`;
      selectors.summaryItemCount.hidden = totalItems === 0;
    }

    function renderProducts() {
      if (!selectors.products) return;
      selectors.products.replaceChildren();
      if (!state.products.length) {
        setProductStatus(
          copy(
            "ProductEmpty",
            "There are no products available for reservation right now.",
          ),
        );
        return;
      }
      const tier = activeTier();
      const fragment = document.createDocumentFragment();
      state.products.forEach((product) => {
        const selected = selectionFor(product);
        if (!selected) return;
        const quantityInBatch = productQuantity(product.key);
        const card = createElement("article", {
          className: `fbr__product-card${quantityInBatch > 0 ? " fbr__product-card--selected" : ""}`,
          attributes: { "data-product-key": product.key },
        });
        card.append(productImage(product, selected));
        const content = createElement("div", {
          className: "fbr__product-content",
        });
        content.append(
          createElement("span", {
            className: "fbr__scarcity-badge",
            text: copy("ScarcityBadge", "Final planned run"),
          }),
        );
        content.append(
          createElement("h3", {
            className: "fbr__product-title",
            text: product.title,
          }),
        );
        if (quantityInBatch > 0) {
          content.append(
            createElement("span", {
              className: "fbr__in-batch-badge",
              text: copy("InYourBatch", "In your batch"),
              attributes: {
                "aria-label": `${product.title}: ${copy("InYourBatch", "In your batch")} (${quantityInBatch} item${quantityInBatch === 1 ? "" : "s"})`,
              },
            }),
          );
        }
        const selectedDescription = selected.title || product.description;
        if (selectedDescription)
          content.append(
            createElement("p", {
              className: "fbr__product-description",
              text: selectedDescription,
            }),
          );
        const rating = productRating(product);
        if (rating) content.append(rating);
        if (product.variants.length > 1) {
          content.append(
            createElement("span", {
              className: "fbr__variant-label",
              text: "Bottle size",
            }),
          );
          const select = createElement("select", {
            className: "fbr__variant-select",
            attributes: {
              "data-variant-select": product.key,
              "aria-label": product.title,
            },
          });
          product.variants.forEach((variant) => {
            const option = createElement("option", {
              text: variant.title || product.title,
              attributes: { value: variant.key },
            });
            option.selected = variant.key === selected.key;
            option.disabled = !variant.available;
            select.append(option);
          });
          content.append(select);
        }
        const price = priceFor(product, selected, tier);
        const purchasePanel = createElement("div", {
          className: "fbr__purchase-panel",
        });
        purchasePanel.append(
          createElement("span", {
            className: "fbr__purchase-label",
            text: "Final Batch price",
          }),
        );
        const priceRow = createElement("div", { className: "fbr__price-row" });
        const regularPrice = basePrice(product, selected);
        if (
          tier &&
          regularPrice !== null &&
          price !== null &&
          price < regularPrice
        ) {
          priceRow.append(
            createElement("span", {
              className: "fbr__price-original",
              text: formatMoney(regularPrice),
            }),
          );
        }
        priceRow.append(
          createElement("span", {
            className: "fbr__price",
            text: formatMoney(price),
          }),
        );
        if (tier)
          priceRow.append(
            createElement("span", {
              className: "fbr__save-pill",
              text: `Save ${Math.round((discountFraction(tier.raw) || 0) * 100)}%`,
            }),
          );
        purchasePanel.append(priceRow);
        const topTier = state.tiers[state.tiers.length - 1];
        const lowestPrice = topTier
          ? priceFor(product, selected, topTier)
          : null;
        if (
          topTier &&
          lowestPrice !== null &&
          regularPrice !== null &&
          lowestPrice < regularPrice
        )
          purchasePanel.append(
            createElement("p", {
              className: "fbr__lowest-price",
              text: `Save up to ${Math.round((discountFraction(topTier.raw) || 0) * 100)}%: ${formatMoney(lowestPrice)} at ${topTier.threshold}+ items`,
            }),
          );
        content.append(purchasePanel);
        const controls = createElement("div", {
          className: "fbr__card-controls",
        });
        const quantity = createElement("div", {
          className: "fbr__quantity fbr__quantity-stepper",
        });
        quantity.append(
          createElement("button", {
            text: "−",
            attributes: {
              type: "button",
              "data-action": "decrease-card-quantity",
              "aria-label": `Decrease ${product.title}`,
            },
          }),
        );
        quantity.append(
          createElement("input", {
            attributes: {
              type: "number",
              min: "1",
              value: "5",
              inputmode: "numeric",
              "data-card-quantity": product.key,
              "aria-label": `Quantity for ${product.title}`,
            },
          }),
        );
        quantity.append(
          createElement("button", {
            text: "+",
            attributes: {
              type: "button",
              "data-action": "increase-card-quantity",
              "aria-label": `Increase ${product.title}`,
            },
          }),
        );
        controls.append(quantity);
        const quickAdds = createElement("div", {
          className: "fbr__quick-adds",
          attributes: { "aria-label": `Quick add ${product.title}` },
        });
        [5, 10, 25].forEach((amount) =>
          quickAdds.append(
            createElement("button", {
              className: "fbr__quick-add-chip",
              text: `+${amount}`,
              attributes: {
                type: "button",
                "data-action": "quick-add",
                "data-product-key": product.key,
                "data-quantity": amount,
                disabled: state.closed ? "disabled" : null,
              },
            }),
          ),
        );
        controls.append(quickAdds);
        const addButton = createElement("button", {
          className: "fbr__button fbr__button--quick-add",
          text:
            selected.available && !state.closed
              ? copy("QuickAdd", "Add to reservation")
              : copy("Unavailable", "Unavailable"),
          attributes: {
            type: "button",
            "data-action": "add-to-cart",
            "data-product-key": product.key,
            disabled: !selected.available || state.closed ? "disabled" : null,
          },
        });
        controls.append(addButton);
        content.append(controls);
        card.append(content);
        fragment.append(card);
      });
      selectors.products.append(fragment);
      initialiseProductRatings();
      setProductStatus("");
    }

    function renderSummary() {
      const totalItems = itemCount();
      const hasItems = totalItems > 0;
      updateCartCounts(totalItems);
      updateSummaryItemCount(totalItems);
      if (selectors.summaryEmpty) selectors.summaryEmpty.hidden = hasItems;
      if (selectors.summaryLines) selectors.summaryLines.replaceChildren();
      const tier = activeTier();
      const fragment = document.createDocumentFragment();
      state.cart.forEach((item) => {
        const found = getVariant(item.productKey, item.variantKey);
        if (!found) return;
        const price = priceFor(found.product, found.variant, tier);
        const line = createElement("li", {
          className: "fbr__summary-line fbr__summary-line--with-thumbnail",
        });
        const top = createElement("div", {
          className: "fbr__summary-line-top",
        });
        const itemTitle =
          found.variant.title && found.variant.title !== found.product.title
            ? `${found.product.title} — ${found.variant.title}`
            : found.product.title;
        top.append(
          createElement("span", {
            className: "fbr__summary-line-title",
            text: itemTitle,
          }),
        );
        top.append(
          createElement("span", {
            className: "fbr__summary-line-price",
            text: formatMoney(price === null ? null : price * item.quantity),
          }),
        );
        const meta = createElement("div", {
          className: "fbr__summary-line-meta",
        });
        meta.append(
          createElement("span", {
            text: `${item.quantity} × ${formatMoney(price)}`,
          }),
        );
        const controls = createElement("div", {
          className: "fbr__summary-line-controls",
          attributes: {
            role: "group",
            "aria-label": `Edit quantity for ${itemTitle}`,
          },
        });
        const quantity = createElement("div", {
          className: "fbr__summary-quantity",
        });
        quantity.append(
          createElement("button", {
            text: "−",
            attributes: {
              type: "button",
              "data-action": "decrease-cart-item",
              "data-product-key": item.productKey,
              "data-variant-key": item.variantKey,
              "aria-label": `Decrease ${itemTitle} quantity`,
            },
          }),
        );
        quantity.append(
          createElement("span", {
            text: String(item.quantity),
            attributes: {
              "aria-live": "polite",
              "aria-label": `${item.quantity} ${item.quantity === 1 ? "item" : "items"}`,
            },
          }),
        );
        quantity.append(
          createElement("button", {
            text: "+",
            attributes: {
              type: "button",
              "data-action": "increase-cart-item",
              "data-product-key": item.productKey,
              "data-variant-key": item.variantKey,
              "aria-label": `Increase ${itemTitle} quantity`,
            },
          }),
        );
        controls.append(quantity);
        controls.append(
          createElement("button", {
            className: "fbr__link-button",
            text: copy("Remove", "Remove"),
            attributes: {
              type: "button",
              "data-action": "remove-cart-item",
              "data-product-key": item.productKey,
              "data-variant-key": item.variantKey,
              "aria-label": `${copy("Remove", "Remove")} ${itemTitle}`,
            },
          }),
        );
        meta.append(controls);
        const content = createElement("div", {
          className: "fbr__summary-line-content",
        });
        content.append(top, meta);
        line.append(summaryThumbnail(found.product, found.variant), content);
        fragment.append(line);
      });
      if (selectors.summaryLines) selectors.summaryLines.append(fragment);
      const total = cartTotal();
      const listPriceTotal = cartListPriceTotal();
      const savings =
        listPriceTotal !== null && total !== null
          ? Math.max(0, listPriceTotal - total)
          : 0;
      const activeDiscount = tier
        ? Math.round((discountFraction(tier.raw) || 0) * 100)
        : 0;
      if (selectors.summaryTotal) selectors.summaryTotal.hidden = !hasItems;
      if (selectors.summaryTotalValue)
        selectors.summaryTotalValue.textContent = formatMoney(total);
      if (selectors.summarySezzle)
        selectors.summarySezzle.hidden = !hasItems || total === null;
      if (selectors.summarySezzleValue)
        selectors.summarySezzleValue.textContent = formatMoney(total);
      if (selectors.summaryTier) {
        selectors.summaryTier.textContent = tier
          ? `Current tier: ${activeDiscount}% off`
          : "Current tier: free shipping (1–4 items)";
        selectors.summaryTier.hidden = !hasItems;
      }
      if (selectors.summarySavings) {
        selectors.summarySavings.textContent =
          savings > 0 ? `You’re saving ${formatMoney(savings)}.` : "";
        selectors.summarySavings.hidden = !hasItems || savings <= 0;
      }
      if (selectors.reservedUnits) {
        const rawReservedValue = pick(state.config, [
          "reserved_units",
          "reservedUnits",
          "total_reserved_units",
          "totalReservedUnits",
        ]);
        const reservedValue =
          rawReservedValue === null ||
          rawReservedValue === undefined ||
          rawReservedValue === ""
            ? NaN
            : Number(rawReservedValue);
        const hasAuthoritativeValue =
          showReservedUnits &&
          Number.isFinite(reservedValue) &&
          reservedValue >= 0 &&
          Math.floor(reservedValue) === reservedValue;
        selectors.reservedUnits.hidden = !hasAuthoritativeValue;
        selectors.reservedUnits.textContent = hasAuthoritativeValue
          ? `${new Intl.NumberFormat(dataset.locale || "en-US").format(reservedValue)} units reserved so far`
          : "";
      }
      updateCartDockVisibility(hasItems);
      if (selectors.cartDockShipping) {
        selectors.cartDockShipping.hidden = !hasItems;
        selectors.cartDockShipping.textContent = "Free shipping unlocked";
      }
      if (selectors.cartDockTotal) {
        selectors.cartDockTotal.textContent = hasItems
          ? formatMoney(total)
          : "Start building your batch";
      }
      if (selectors.cartDockTier) {
        const next = nextTier();
        const nextDiscount = Math.round(
          (discountFraction(next?.raw) || 0) * 100,
        );
        selectors.cartDockTier.hidden = !hasItems;
        selectors.cartDockTier.textContent = tier
          ? `Save ${activeDiscount}% unlocked`
          : next && nextDiscount > 0
            ? `Add ${next.threshold - totalItems} more for ${nextDiscount}% off`
            : "More savings unlocked";
        selectors.cartDockTier.classList.toggle(
          "is-pending",
          !tier && hasItems,
        );
      }
      if (selectors.scrollToForm)
        selectors.scrollToForm.disabled = !hasItems || state.closed;
    }

    function updateUI() {
      renderTiers();
      renderProducts();
      renderSummary();
    }

    function saveAndUpdate() {
      persistCart();
      updateUI();
    }

    function changeCardQuantity(button, change) {
      const card = button.closest(".fbr__product-card");
      const input = card && card.querySelector("[data-card-quantity]");
      if (!input) return;
      input.value = Math.max(1, (Number(input.value) || 1) + change);
    }

    function addToCart(productKey, quantity) {
      const product = getProduct(productKey);
      if (!product || state.closed) return;
      const selected = selectionFor(product);
      if (!selected || !selected.available) return;
      const cap = Number(state.config?.maxQuantity || 100);
      const remaining = cap - itemCount();
      if (remaining <= 0) {
        setProductStatus(`Reservations are limited to ${cap} items.`);
        return;
      }
      const requested = Math.max(1, Math.floor(Number(quantity) || 1));
      const appliedQuantity = Math.min(requested, remaining);
      const existing = state.cart.find(
        (item) =>
          item.productKey === product.key && item.variantKey === selected.key,
      );
      if (existing) existing.quantity += appliedQuantity;
      else
        state.cart.push({
          productKey: product.key,
          variantKey: selected.key,
          quantity: appliedQuantity,
        });
      saveAndUpdate();
      setProductStatus(
        appliedQuantity < requested
          ? `Added ${appliedQuantity}; ${cap}-item limit reached.`
          : copy("Added", "Added"),
      );
    }

    function changeCartItemQuantity(productKey, variantKey, amount) {
      if (state.closed) return;
      const item = state.cart.find(
        (candidate) =>
          candidate.productKey === productKey &&
          candidate.variantKey === variantKey,
      );
      if (!item) return;
      if (amount < 0) {
        if (item.quantity <= 1) {
          state.cart = state.cart.filter((candidate) => candidate !== item);
        } else {
          item.quantity -= 1;
        }
      } else {
        const cap = Number(state.config?.maxQuantity || 100);
        if (itemCount() >= cap) {
          setProductStatus(`Reservations are limited to ${cap} items.`);
          return;
        }
        item.quantity += 1;
      }
      saveAndUpdate();
    }

    function scrollToReservationForm() {
      const formSection = root.querySelector(".fbr__form-section");
      formSection?.scrollIntoView({ behavior: "smooth", block: "start" });
      window.setTimeout(
        () =>
          formSection
            ?.querySelector("input, select, button")
            ?.focus({ preventScroll: true }),
        450,
      );
    }

    function closeAcknowledgement(returnFocus = true) {
      if (!selectors.acknowledgement || selectors.acknowledgement.hidden)
        return;
      selectors.acknowledgement.hidden = true;
      root.classList.remove("is-acknowledgement-open");
      if (returnFocus)
        state.acknowledgementTrigger?.focus?.({ preventScroll: true });
      state.acknowledgementTrigger = null;
    }

    function openAcknowledgement(trigger) {
      if (state.closed || !state.cart.length || !selectors.acknowledgement)
        return;
      state.acknowledgementTrigger = trigger || document.activeElement;
      if (selectors.finalSaleError) selectors.finalSaleError.hidden = true;
      selectors.acknowledgement.hidden = false;
      root.classList.add("is-acknowledgement-open");
      window.setTimeout(
        () => selectors.acknowledgementDialog?.focus({ preventScroll: true }),
        0,
      );
    }

    function populateStates() {
      if (!selectors.stateSelect) return;
      const fragment = document.createDocumentFragment();
      ELIGIBLE_STATES.forEach(([code, name]) =>
        fragment.append(
          createElement("option", { text: name, attributes: { value: code } }),
        ),
      );
      selectors.stateSelect.append(fragment);
    }

    function isRestrictedZip(value) {
      const match = String(value || "").match(/^\s*(\d{5})/);
      if (!match) return false;
      const zip = Number(match[1]);
      return (zip >= 90001 && zip <= 96162) || (zip >= 37010 && zip <= 38589);
    }

    function validateForm(form) {
      clearFormError();
      const stateField = form.elements.state;
      const zipField = form.elements.zip;
      const ageConfirmedField = form.elements.age_confirmed;
      [stateField, zipField, ageConfirmedField].forEach(
        (field) => field && field.setCustomValidity(""),
      );
      if (stateField && RESTRICTED_STATES.has(stateField.value)) {
        stateField.setCustomValidity(
          copy(
            "StateError",
            "Reservations are not available for the selected state.",
          ),
        );
        showFormError(
          copy(
            "StateError",
            "Reservations are not available for the selected state.",
          ),
        );
        stateField.focus();
        return false;
      }
      if (zipField && isRestrictedZip(zipField.value)) {
        zipField.setCustomValidity(
          copy("ZipError", "Reservations are not available for this ZIP code."),
        );
        showFormError(
          copy("ZipError", "Reservations are not available for this ZIP code."),
        );
        zipField.focus();
        return false;
      }
      if (!ageConfirmedField || !ageConfirmedField.checked) {
        ageConfirmedField?.setCustomValidity(
          copy(
            "AgeError",
            "Please confirm that you are at least 21 years old to reserve.",
          ),
        );
        showFormError(
          copy(
            "AgeError",
            "Please confirm that you are at least 21 years old to reserve.",
          ),
        );
        ageConfirmedField?.focus();
        return false;
      }
      if (!form.checkValidity()) {
        form.reportValidity();
        return false;
      }
      if (!state.cart.length) {
        showFormError(
          copy(
            "CartError",
            "Please add at least one product before submitting your reservation.",
          ),
        );
        selectors.summary?.scrollIntoView({
          behavior: "smooth",
          block: "center",
        });
        return false;
      }
      return true;
    }

    function newIdempotencyKey() {
      if (window.crypto?.randomUUID) return window.crypto.randomUUID();
      const random = window.crypto?.getRandomValues
        ? window.crypto.getRandomValues(new Uint32Array(4))
        : [Date.now(), Math.random() * 1e9];
      return Array.from(random, (value) => Number(value).toString(36))
        .join("-")
        .slice(0, 128);
    }

    function reservationPayload(form, idempotencyKey) {
      const data = new FormData(form);
      const items = state.cart.map((item) => {
        const found = getVariant(item.productKey, item.variantKey);
        return {
          variantId: found?.variant.id || item.variantKey,
          quantity: item.quantity,
        };
      });
      return {
        idempotencyKey,
        items,
        firstName: data.get("first_name"),
        lastName: data.get("last_name"),
        email: data.get("email"),
        phone: data.get("phone") || "",
        ageConfirmed: data.get("age_confirmed") === "true",
        termsAccepted: data.get("terms_accepted") === "true",
        shippingAddress: {
          address1: data.get("address_1"),
          address2: data.get("address_2"),
          city: data.get("city"),
          state: data.get("state"),
          zip: data.get("zip"),
        },
      };
    }

    function isValidEditToken(value) {
      return typeof value === "string" && /^[a-f0-9]{64}$/.test(value);
    }

    function removeEditTokenFromAddress() {
      const url = new URL(window.location.href);
      if (!url.searchParams.has("token")) return;
      url.searchParams.delete("token");
      window.history.replaceState({}, document.title, `${url.pathname}${url.search}${url.hash}`);
    }

    function setFormValue(form, name, value) {
      const field = form?.elements?.[name];
      if (field) field.value = stringValue(value);
    }

    function enterEditMode(reservation, token) {
      if (!selectors.form || !isValidEditToken(token)) return;
      const form = selectors.form;
      const address = reservation.shippingAddress || {};
      state.editToken = token;
      state.editVersion = Math.max(1, Math.floor(Number(reservation.editVersion) || 1));
      setFormValue(form, "first_name", reservation.firstName);
      setFormValue(form, "last_name", reservation.lastName);
      setFormValue(form, "email", reservation.email);
      setFormValue(form, "phone", reservation.phone);
      setFormValue(form, "address_1", address.address1);
      setFormValue(form, "address_2", address.address2);
      setFormValue(form, "city", address.city);
      setFormValue(form, "state", address.state);
      setFormValue(form, "zip", address.zip);
      const emailField = form.elements.email;
      if (emailField) {
        emailField.readOnly = true;
        emailField.setAttribute("aria-readonly", "true");
      }
      if (selectors.editNotice) selectors.editNotice.hidden = false;
      if (selectors.editNoticeMessage)
        selectors.editNoticeMessage.textContent =
          "Review your saved items and delivery details, then confirm the required checkboxes to save your changes before reservations close.";
      if (selectors.submit)
        selectors.submit.textContent = "Save reservation changes";
      window.requestAnimationFrame(() => {
        updateStickyHeaderOffset();
        selectors.formSection?.scrollIntoView({ behavior: "auto", block: "start" });
        form.elements.first_name?.focus({ preventScroll: true });
      });
    }

    function safeEditUrl(value) {
      if (!value) return "#";
      try {
        const url = new URL(value, window.location.origin);
        if (url.origin !== window.location.origin) return "#";
        const token = url.searchParams.get("token");
        if (isValidEditToken(token)) {
          const editPage = new URL(window.location.pathname, window.location.origin);
          editPage.searchParams.set("token", token);
          return `${editPage.pathname}${editPage.search}${editPage.hash}`;
        }
        return `${url.pathname}${url.search}${url.hash}`;
      } catch (error) {
        return "#";
      }
    }

    function reservationReceipt(cart) {
      const tier = activeTier();
      const items = cart.reduce((lines, item) => {
        const found = getVariant(item.productKey, item.variantKey);
        if (!found) return lines;
        const unitPrice = priceFor(found.product, found.variant, tier);
        const listPrice = basePrice(found.product, found.variant);
        lines.push({
          title:
            found.variant.title && found.variant.title !== found.product.title
              ? `${found.product.title} — ${found.variant.title}`
              : found.product.title,
          image: found.variant.image || found.product.image || "",
          quantity: item.quantity,
          unitPrice,
          listPrice,
          lineTotal:
            unitPrice === null ? null : unitPrice * Math.max(1, item.quantity),
        });
        return lines;
      }, []);
      const quantity = items.reduce((total, item) => total + item.quantity, 0);
      const subtotal = items.reduce(
        (total, item) =>
          total +
          (item.listPrice === null ? 0 : item.listPrice * item.quantity),
        0,
      );
      const total = items.reduce(
        (sum, item) => sum + (item.lineTotal === null ? 0 : item.lineTotal),
        0,
      );
      return {
        items,
        quantity,
        tierPercent: Math.round((discountFraction(tier?.raw) || 0) * 100),
        subtotal,
        total,
        savings: Math.max(0, subtotal - total),
      };
    }

    function renderConfirmationItems(items) {
      if (!selectors.confirmationItems) return;
      selectors.confirmationItems.replaceChildren();
      const fragment = document.createDocumentFragment();
      items.forEach((item) => {
        const line = createElement("li", {
          className: "fbr__confirmation-line",
        });
        if (item.image) {
          line.append(
            createElement("img", {
              className: "fbr__confirmation-line-image",
              attributes: {
                src: item.image,
                alt: "",
                width: "80",
                height: "80",
                loading: "lazy",
              },
            }),
          );
        }
        const content = createElement("div", {
          className: "fbr__confirmation-line-content",
        });
        content.append(
          createElement("strong", {
            className: "fbr__confirmation-line-title",
            text: item.title,
          }),
        );
        content.append(
          createElement("span", {
            className: "fbr__confirmation-line-meta",
            text: `${item.quantity} × ${formatMoney(item.unitPrice)}`,
          }),
        );
        line.append(content);
        line.append(
          createElement("strong", {
            className: "fbr__confirmation-line-total",
            text: formatMoney(item.lineTotal),
          }),
        );
        fragment.append(line);
      });
      selectors.confirmationItems.append(fragment);
    }

    function showConfirmation(response, receipt = {}) {
      const confirmation =
        response?.reservation || response?.confirmation || response || {};
      const heading =
        pick(confirmation, ["heading", "title"]) ||
        "Your Final Batch reservation is saved.";
      const quantity = Number(confirmation.quantity || receipt.quantity || 0);
      const reservationMessage =
        pick(confirmation, ["message", "detail"]) ||
        pick(response, ["message"]) ||
        `${copy("Success", "Your reservation request has been received.")} ${quantity ? `${quantity} item${quantity === 1 ? "" : "s"} reserved.` : ""} Your payment link will arrive November 1.`;
      const confirmationEmail = stringValue(receipt.confirmationEmail)
        .trim()
        .slice(0, 254);
      const emailNotice = confirmationEmail
        ? `A reservation confirmation email is on its way to ${confirmationEmail}. It may take a few minutes to arrive.`
        : "A reservation confirmation email is on its way. It may take a few minutes to arrive.";
      const message = `${reservationMessage} ${emailNotice}`;
      const editUrl = safeEditUrl(
        pick(confirmation, ["edit_url", "editUrl", "edit_link", "editLink"]) ||
          pick(response, ["edit_url", "editUrl", "edit_link", "editLink"]),
      );
      if (selectors.confirmationHeading)
        selectors.confirmationHeading.textContent = heading;
      if (selectors.confirmationMessage)
        selectors.confirmationMessage.textContent = message;
      renderConfirmationItems(receipt.items || []);
      const tierPercent = Math.round(
        Number(
          pick(confirmation, ["tier_percent", "tierPercent"]) ||
            receipt.tierPercent ||
            0,
        ),
      );
      const total =
        moneyFrom(confirmation, ["total_cents", "totalCents", "total"]) ??
        receipt.total;
      const subtotal =
        moneyFrom(confirmation, [
          "subtotal_cents",
          "subtotalCents",
          "subtotal",
        ]) ?? receipt.subtotal;
      const savings =
        Number.isFinite(total) && Number.isFinite(subtotal)
          ? Math.max(0, subtotal - total)
          : receipt.savings || 0;
      if (selectors.confirmationItemCount)
        selectors.confirmationItemCount.textContent = `${quantity} item${quantity === 1 ? "" : "s"}`;
      if (selectors.confirmationTier)
        selectors.confirmationTier.textContent = tierPercent
          ? `${tierPercent}% off unlocked`
          : "Free shipping included";
      if (selectors.confirmationSavings)
        selectors.confirmationSavings.textContent = formatMoney(savings);
      if (selectors.confirmationSavingsRow)
        selectors.confirmationSavingsRow.hidden = savings <= 0;
      if (selectors.confirmationTotal)
        selectors.confirmationTotal.textContent = formatMoney(total);
      if (selectors.editLink) {
        selectors.editLink.textContent = copy(
          "Edit",
          "Edit reservation details",
        );
        selectors.editLink.href =
          editUrl === "#" ? `#${selectors.form.id || ""}` : editUrl;
      }
      if (selectors.summary) selectors.summary.hidden = true;
      if (selectors.cartDock) selectors.cartDock.hidden = true;
      selectors.form.hidden = true;
      selectors.confirmation.hidden = false;
      window.requestAnimationFrame(() => {
        updateStickyHeaderOffset();
        selectors.confirmation.scrollIntoView({ behavior: "auto", block: "start" });
        selectors.confirmation.focus({ preventScroll: true });
      });
    }

    async function submitReservation(event) {
      event.preventDefault();
      const form = event.currentTarget;
      if (state.previewFallback || state.prelaunch) {
        showFormError(
          state.prelaunch
            ? copy(
                "PrelaunchMessage",
                "Reservations are not open yet. Please check back soon.",
              )
            : "This is a private theme preview. Reservation submission is disabled.",
        );
        return;
      }
      if (state.closed || !validateForm(form)) return;
      const button = selectors.submit;
      const defaultLabel = button.textContent;
      button.disabled = true;
      button.textContent = copy("Submitting", "Submitting reservation…");
      state.submissionKey = state.submissionKey || newIdempotencyKey();
      try {
        const payload = reservationPayload(form, state.submissionKey);
        const isEditing = isValidEditToken(state.editToken);
        if (isEditing) {
          payload.token = state.editToken;
          payload.expectedVersion = state.editVersion;
          delete payload.email;
        }
        const response = await fetch(proxyUrl(isEditing ? "/reservation" : "/reserve"), {
          method: isEditing ? "PATCH" : "POST",
          credentials: "same-origin",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            "Idempotency-Key": state.submissionKey,
          },
          body: JSON.stringify(payload),
        });
        const contentType = response.headers.get("content-type") || "";
        const body = contentType.includes("application/json")
          ? await response.json()
          : {};
        if (!response.ok)
          throw new Error(
            pick(body, ["error", "message"]) ||
              copy(
                "SubmitError",
                "We could not submit your reservation. Please review your details and try again.",
              ),
          );
        const receipt = {
          ...reservationReceipt(state.cart),
          confirmationEmail: isEditing ? form.elements.email?.value || "" : payload.email,
        };
        state.cart = [];
        state.editToken = null;
        state.editVersion = null;
        persistCart();
        updateUI();
        showConfirmation(body, receipt);
        state.submissionKey = null;
      } catch (error) {
        showFormError(
          error.message ||
            copy(
              "SubmitError",
              "We could not submit your reservation. Please review your details and try again.",
            ),
        );
        button.disabled = false;
        button.textContent = defaultLabel;
        state.submissionKey = null;
      }
    }

    function updateCountdown() {
      const deadlineTime = state.deadline ? Date.parse(state.deadline) : NaN;
      const expired =
        Number.isFinite(deadlineTime) && Date.now() >= deadlineTime;
      if (expired) state.closed = true;
      const remaining = Math.max(
        0,
        (Number.isFinite(deadlineTime) ? deadlineTime : Date.now()) -
          Date.now(),
      );
      const values = {
        days: Math.floor(remaining / 86400000),
        hours: Math.floor((remaining % 86400000) / 3600000),
        minutes: Math.floor((remaining % 3600000) / 60000),
      };
      Object.entries(values).forEach(([name, value]) => {
        const element = root.querySelector(`[data-countdown-${name}]`);
        if (element) element.textContent = String(value).padStart(2, "0");
      });
      const closingTonight = remaining > 0 && remaining <= 86400000;
      selectors.countdownCard?.classList.toggle("is-final-day", closingTonight);
      if (selectors.countdownTitle)
        selectors.countdownTitle.textContent = closingTonight
          ? dataset.countdownFinalDayLabel || "Closes tonight."
          : dataset.countdownDefaultLabel || "Time remaining to reserve";
      if (selectors.openContent) selectors.openContent.hidden = state.closed;
      if (selectors.closed) selectors.closed.hidden = !state.closed;
      if (state.closed && selectors.closed && !selectors.closed.hidden)
        selectors.closed.setAttribute("aria-hidden", "false");
    }

    function applyDeadline(value) {
      state.deadline = value || dataset.fallbackDeadline || null;
      const deadlineLabel = root.querySelector("[data-deadline-date]");
      if (deadlineLabel)
        deadlineLabel.textContent = formatDeadline(state.deadline);
      if (selectors.summaryDeadline) {
        const validDeadline = Number.isFinite(Date.parse(state.deadline || ""));
        selectors.summaryDeadline.hidden = !validDeadline;
        selectors.summaryDeadline.textContent = validDeadline
          ? `${dataset.summaryDeadlineLabel || "Reservations close"}: ${formatDeadline(state.deadline)}`
          : "";
      }
      updateCountdown();
      if (state.countdownTimer) window.clearInterval(state.countdownTimer);
      state.countdownTimer = window.setInterval(() => {
        const wasClosed = state.closed;
        updateCountdown();
        if (!wasClosed && state.closed) updateUI();
      }, 60000);
    }

    async function loadSavedReservation() {
      const token = new URLSearchParams(window.location.search).get("token");
      if (!isValidEditToken(token)) return;
      try {
        const response = await fetch(
          proxyUrl(`/reservation?token=${encodeURIComponent(token)}`),
          {
            credentials: "same-origin",
            headers: { Accept: "application/json" },
          },
        );
        if (!response.ok) {
          setProductStatus("We could not load this reservation link. Please use the link from your confirmation email or contact support.");
          return;
        }
        const payload = await response.json();
        const reservation = payload?.reservation || {};
        if (reservation.editable !== true) {
          setProductStatus("This Final Batch reservation can no longer be edited. Please use your payment email or contact support if you need help.");
          removeEditTokenFromAddress();
          return;
        }
        const savedItems = Array.isArray(reservation.items)
          ? reservation.items
          : [];
        const restored = savedItems
          .map((item) => {
            const product = state.products.find((candidate) =>
              candidate.variants.some(
                (variant) => variant.id === item.variantId,
              ),
            );
            const variant = product?.variants.find(
              (candidate) => candidate.id === item.variantId,
            );
            return product && variant
              ? {
                  productKey: product.key,
                  variantKey: variant.key,
                  quantity: Math.max(1, Math.floor(Number(item.quantity) || 1)),
                }
              : null;
          })
          .filter(Boolean);
        if (restored.length) {
          state.cart = restored;
          persistCart();
          enterEditMode(reservation, token);
          removeEditTokenFromAddress();
          setProductStatus("Your saved reservation is ready to review and edit.");
        } else {
          setProductStatus("We could not load the saved Final Batch items. Please contact support for help with this reservation.");
        }
      } catch (error) {
        setProductStatus("We could not load this reservation link. Please use the link from your confirmation email or contact support.");
      }
    }

    function enablePreviewFallback() {
      const previewMessage = copy(
        "PreviewNotice",
        "Preview mode only. Reservations are not submitted from this unpublished theme.",
      );
      state.previewFallback = true;
      state.config = PREVIEW_FALLBACK_CONFIG;
      state.products = normalizeProducts(state.config.products);
      state.tiers = normalizeTiers(state.config.tiers);
      state.closed = false;
      restoreCart();
      applyDeadline(null);
      updateUI();

      if (!state.prelaunch) {
        let notice = root.querySelector("[data-final-batch-preview-notice]");
        if (!notice) {
          notice = createElement("div", {
            className: "fbr__preview-notice",
            attributes: {
              "data-final-batch-preview-notice": "",
              role: "status",
            },
          });
          (selectors.openContent || root).prepend(notice);
        }
        notice.textContent = previewMessage;
      }
      if (selectors.submit) {
        selectors.submit.disabled = true;
        selectors.submit.setAttribute("aria-disabled", "true");
        selectors.submit.textContent = state.prelaunch
          ? copy("PrelaunchButton", "Reservations opening soon")
          : "Preview only";
        selectors.submit.setAttribute(
          "aria-label",
          state.prelaunch
            ? copy("PrelaunchMessage", "Reservations are not open yet.")
            : previewMessage,
        );
      }
    }

    async function loadConfig() {
      try {
        const response = await fetch(proxyUrl("/config"), {
          credentials: "same-origin",
          headers: { Accept: "application/json" },
        });
        if (!response.ok) throw new Error("Configuration request failed");
        const payload = await response.json();
        state.config = payload.config || payload;
        state.products = normalizeProducts(state.config.products);
        state.tiers = normalizeTiers(state.config.tiers);
        state.closed =
          state.config.closed === true ||
          String(state.config.status || "").toLowerCase() === "closed";
        restoreCart();
        applyDeadline(
          pick(state.config, [
            "deadline",
            "reservation_deadline",
            "reservationDeadline",
            "closes_at",
            "closesAt",
            "closeAt",
          ]) || dataset.fallbackDeadline,
        );
        await loadSavedReservation();
        updateUI();
        if (state.prelaunch && selectors.submit) {
          selectors.submit.disabled = true;
          selectors.submit.setAttribute("aria-disabled", "true");
          selectors.submit.textContent = copy(
            "PrelaunchButton",
            "Reservations opening soon",
          );
        }
      } catch (error) {
        if (isShopifyThemePreview()) {
          enablePreviewFallback();
          return;
        }
        setProductStatus(
          copy(
            "ConfigError",
            "We could not load the final-batch details. Please refresh and try again.",
          ),
        );
        if (selectors.scrollToForm) selectors.scrollToForm.disabled = true;
      }
    }

    root.addEventListener("click", (event) => {
      const control = event.target.closest("[data-action]");
      if (!control || !root.contains(control)) return;
      const action = control.dataset.action;
      if (action === "decrease-card-quantity") changeCardQuantity(control, -1);
      if (action === "increase-card-quantity") changeCardQuantity(control, 1);
      if (action === "toggle-cart-dock") toggleCartDockMinimizedState();
      if (action === "close-reservation-acknowledgement")
        closeAcknowledgement(true);
      if (action === "continue-to-reservation-form") {
        if (!selectors.finalSaleAcknowledgement?.checked) {
          if (selectors.finalSaleError) selectors.finalSaleError.hidden = false;
          selectors.finalSaleAcknowledgement?.focus({ preventScroll: true });
          return;
        }
        closeAcknowledgement(false);
        scrollToReservationForm();
      }
      if (action === "add-to-cart") {
        const card = control.closest(".fbr__product-card");
        const input = card && card.querySelector("[data-card-quantity]");
        addToCart(
          control.dataset.productKey,
          Math.max(1, Math.floor(Number(input?.value) || 1)),
        );
      }
      if (action === "quick-add")
        addToCart(
          control.dataset.productKey,
          Number(control.dataset.quantity) || 1,
        );
      if (action === "decrease-cart-item")
        changeCartItemQuantity(
          control.dataset.productKey,
          control.dataset.variantKey,
          -1,
        );
      if (action === "increase-cart-item")
        changeCartItemQuantity(
          control.dataset.productKey,
          control.dataset.variantKey,
          1,
        );
      if (action === "remove-cart-item") {
        state.cart = state.cart.filter(
          (item) =>
            !(
              item.productKey === control.dataset.productKey &&
              item.variantKey === control.dataset.variantKey
            ),
        );
        saveAndUpdate();
      }
    });

    root.addEventListener("change", (event) => {
      const select = event.target.closest("[data-variant-select]");
      if (select) {
        state.selections[select.dataset.variantSelect] = select.value;
        renderProducts();
      }
      if (event.target.matches("[data-card-quantity]"))
        event.target.value = Math.max(
          1,
          Math.floor(Number(event.target.value) || 1),
        );
    });

    selectors.scrollToForm?.addEventListener("click", () =>
      openAcknowledgement(selectors.scrollToForm),
    );

    root.addEventListener("keydown", (event) => {
      if (
        event.key === "Escape" &&
        selectors.acknowledgement &&
        !selectors.acknowledgement.hidden
      ) {
        event.preventDefault();
        closeAcknowledgement(true);
      }
    });

    selectors.form?.addEventListener("submit", submitReservation);
    selectors.editLink?.addEventListener("click", (event) => {
      if (selectors.editLink.getAttribute("href")?.startsWith("#")) {
        event.preventDefault();
        selectors.confirmation.hidden = true;
        selectors.form.hidden = false;
        if (selectors.summary) selectors.summary.hidden = false;
        updateUI();
        selectors.form.scrollIntoView({ behavior: "smooth", block: "start" });
        selectors.form
          .querySelector("input, select")
          ?.focus({ preventScroll: true });
      }
    });

    populateStates();
    initialiseHeroFallback();
    arrangeSummaryForViewport();
    initialiseCartDockObserver();
    updateCartDockMinimizedState();
    updateStickyHeaderOffset();
    summaryMobileQuery.addEventListener("change", arrangeSummaryForViewport);
    window.addEventListener("resize", updateStickyHeaderOffset, {
      passive: true,
    });
    applyDeadline(dataset.fallbackDeadline);
    loadConfig();
  }

  function start() {
    document.querySelectorAll("[data-final-batch-reservation]").forEach(init);
  }

  if (document.readyState === "loading")
    document.addEventListener("DOMContentLoaded", start, { once: true });
  else start();
})();
